'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../../core/utils');

var _utils2 = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationTicketExtraServices = function () {
    function WinresReservationTicketExtraServices($scope, $timeout, $location, productService, localizationService, $document) {
        _classCallCheck(this, WinresReservationTicketExtraServices);

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$location = $location;
        this.productService = productService;
        this.localizationService = localizationService;
        this.$scope.moment = moment;
        this.$document = $document;

        this.products = []; // List of available products returned by backend
        this.searchProducts = []; // Product chosen by user from above list, no Start/EndDate filled
        this.retrievedProducts = []; // Product returned by backend, Start/EndDate filled,
        // used for adding to cart
        this.$scope.selectedForced = null;

        this.allowChoosingEndDate = false;

        this.terms = [];

        this.prices = [];

        this.open = {
            startDate: false,
            endDate: false
        };
    }

    _createClass(WinresReservationTicketExtraServices, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Destination
            // getContext().DefaultStartDate
            // getContext().DefaultEndDate
            // getContext().Destination
            // getContext().DefaultStartDate
            // getContext().DefaultEndDate
            // getContext().NumAdults
            // getContext().NumChildren
            // getContext().NumInfants
            // getContext().DestinationCode
            // getContext().ChildrenAges
            // getConfirmBookingResult()

            // Set:
            // getContext().DefaultStartDate
            // getContext().DefaultEndDate
            // setMessageToBooking()

            // Other:
            // findOrCreateProductLineByProduct()
            // getOrCreateDummyPassengers()

            var wrc = this.winresReservationContext;
            this.data = this.winresReservationContext.getContext();

            this.isPackage = false;

            if (this.packageType != "") {
                this.$scope.$watch(function () {
                    return _this.data.Destination;
                }, function (destination) {
                    if (_this.data.Destination) {
                        if (_this.data.Destination.Type == _this.packageType) {
                            _this.isPackage = true;
                        }
                    }
                });
            }

            this.today = new Date();

            this.$scope.$watch(function () {
                return _this.data.Destination;
            }, function (destination) {
                if (destination != null && destination.DestinationCode != null) {
                    _this.resetSearchProduct();
                    _this.fetchProducts(destination.DestinationCode);
                }
            });

            this.$scope.$watchGroup([function () {
                return _this.data.DefaultStartDate;
            }, function () {
                return _this.data.DefaultEndDate;
            }], function () {
                if (_this.data.DefaultStartDate != null && _this.data.DefaultEndDate != null && _this.data.Destination != null) {
                    _this.resetSearchProduct();
                    startDateString = null;
                    endDateString = null;
                    _this.fetchProducts(_this.data.Destination.DestinationCode);
                }
            });

            // var startDateString = readUrlPart(this.$location, this.useSeo ? 2 : 1);
            // var endDateString = readUrlPart(this.$location, this.useSeo ? 3 : 2);
            var startDateString = this.winresReservationContext.Params.StartDate;
            var endDateString = this.winresReservationContext.Params.EndDate;

            this.$scope.$watch(function () {
                return _this.searchProducts;
            }, function (products) {
                _this.retrievedProducts = [];
                if (products != null) {
                    for (var i = 0; i < products.length; i++) {
                        _this.terms[i] = {};

                        if (startDateString) {
                            _this.terms[i].startDate = new Date(startDateString);
                        } else if (_this.data.DefaultStartDate) {
                            _this.terms[i].startDate = new Date(_this.data.DefaultStartDate);
                        }

                        if (endDateString) {
                            _this.terms[i].endDate = new Date(endDateString);
                        } else if (_this.data.DefaultEndDate) {
                            _this.terms[i].endDate = new Date(_this.data.DefaultEndDate);
                        }

                        _this.terms[i].destinationCode = products[i].DestinationInfo.DestinationCode;
                        _this.terms[i].productCode = products[i].DestinationInfo.ProductCode;
                        _this.updateEndDateIfLengthIsForced(_this.terms[i].startDate, i);
                    }
                }
            });

            // Some products (extra services) have forced end date one day after
            // the start date. Update end date accordingly.
            /*this.$scope.$watch(() => this.terms.startDate, startDate => {
                this.updateEndDateIfLengthIsForced(startDate);
                this.minEndDate = startDate;
            });*/

            var isInitial = true;
            this.$scope.$watch(function () {
                return _this.terms;
            }, function (terms) {
                for (var i = 0; i < terms.length; i++) {
                    _this.fetchPrices(terms[i], i);
                    // Remember user-selected dates if the user navigates. This is
                    // also used in the search criteria thing.
                    if (!isInitial) {
                        if (_this.terms.startDate) {
                            // Store as ISO date string, since sessionStorage does
                            // not support storing Date objects.
                            _this.data.DefaultStartDate = (0, _utils.formatISODate)(_this.terms.startDate);
                        }
                        if (_this.terms.endDate && (_this.open.endDate || _this.daterangeCalendar === 'true')) {
                            _this.data.DefaultEndDate = (0, _utils.formatISODate)(_this.terms.endDate);
                        }
                    }
                    isInitial = false;
                }
            }, true);
        }
    }, {
        key: 'fetchProducts',
        value: function fetchProducts(destinationCode) {
            var _this2 = this;

            var p = this.getReservableProducts({ DestinationCode: destinationCode });
            p.then(function (products) {
                products = _.each(products, function (product) {
                    product.DestinationInfo.DestinationCode = destinationCode;
                });

                _this2.products = products;

                if (products && products.length > 0) {
                    _this2.searchProducts = products;
                }
            });
        }
    }, {
        key: 'fetchPrices',
        value: function fetchPrices(terms, i) {
            var _this3 = this;

            this.prices = [];
            this.chosenAmounts = [];
            this.availableAmounts = [];
            this.TaxPercent = [];

            if (terms.destinationCode === null) {
                // console.log('[WRT] No destination given');
                return;
            }
            if (terms.productCode === null) {
                // console.log('[WRT] No product chosen');
                return;
            }
            if (terms.startDate === null) {
                // console.log('[WRT] No start date chosen');
                return;
            }
            if (terms.endDate === null) {
                // console.log('[WRT] No end date chosen');
                return;
            }

            var params = {
                DestinationCode: terms.destinationCode,
                ProductCode: terms.productCode,
                StartDate: (0, _utils.formatISODate)(terms.startDate),
                EndDate: (0, _utils.formatISODate)(terms.endDate),
                NumAdults: this.data.NumAdults,
                NumChildren: this.data.NumChildren,
                NumInfants: this.data.NumInfants,
                Flags: ["K1ExtraAllMatchedPrices"]
            };

            // console.log('[WRT] Fetching prices:', params.DestinationCode, params.ProductCode,
            //             params.StartDate, params.EndDate);

            this.getReservableProducts(params).then(function (products) {
                // Set prices to [] here to indicate that the search has been
                // completed, even if the product is missing from the results.
                //this.prices = [];
                if (products.length === 0) {
                    console.log('[WRT] Product seems to be unavailable. Parameters:', params);
                    return;
                } else if (products.length !== 1) {
                    console.error('[WRT] GetReservableProducts should return exactly one result here!', 'Parameters:', params, 'Results:', products);
                    return;
                }
                _this3.retrievedProducts[i] = products;

                //console.log("retrieved products ", this.retrievedProducts);

                _this3.updatePrices(products[0], i);
            });
        }
    }, {
        key: 'updatePrices',
        value: function updatePrices(product, i) {
            // console.log('[WRT] Updating prices for product:',
            //             product.DestinationInfo.DestinationCode,
            //             product.DestinationInfo.ProductCode,
            //             product);
            var prices = product.ReservablePrices || [];
            var capacity = product.Capacity;

            // Temporary solution until multiple product support for Opera is implemented.
            if (this.allowBookingOnlyOne(product)) {
                capacity = Math.min(capacity, 1);
            }

            this.prices[i] = prices;
            //console.log("prices ", this.prices);
            this.TaxPercent[i] = product.TaxPros;
            this.availableAmounts[i] = _.range(0, capacity + 1);
            //console.log(this.availableAmounts);

            this.chosenAmounts[i] = _.fill(new Array(prices.length), 0);

            // Auto-select prices (the first price)
            if (prices.length > 0) {
                var beds = product.DestinationInfo.Beds || 0;
                var extraBeds = product.DestinationInfo.ExtraBeds || 0;
                var adults = this.data.NumAdults || 0;
                var children = this.data.NumChildren || 0;

                var numToSelect = 0;
                if (beds > 0) {
                    var rooms = this.selectEnoughRoomsForPassengers(beds, extraBeds, adults, children);
                    // TODO: If the passengers cannot be accommodated (e.g. not
                    // enough adults or capacity), show the user an error message
                    // instead of setting capacity to 0.
                    numToSelect = rooms || 0;
                } else {
                    numToSelect = adults + children;
                }

                if (capacity < numToSelect) {
                    // Don't select any, as not to fool the user into thinking that he
                    // has selected the product for everyone.
                    this.chosenAmounts[i][0] = 0;
                } else {
                    this.chosenAmounts[i][0] = numToSelect;
                }
            }
        }
    }, {
        key: 'getDropDownValues',
        value: function getDropDownValues() {

            var destinationCode = this.data.DestinationCode;

            var product = _.find(this.data.Products, function (o) {
                return o.Product.DestinationInfo.DestinationCode === destinationCode;
            });

            if (product != null) {
                var amount = product.Amount;
            } else {
                var amount = 0;
            }

            return _.range(this.retrievedProduct.Capacity + 1 - amount);
        }
    }, {
        key: 'isInvalidDate',
        value: function isInvalidDate(date) {
            var formattedDate = date.format('YYYY-MM-DD');
            if (this.daterangeDates) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.daterangeDates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var e = _step.value;

                        if (e.BeginDate === formattedDate && e.Capacity > e.Sold) {
                            return false;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return true;
        }
    }, {
        key: 'addToCart',
        value: function addToCart(index) {
            var _this4 = this;

            if (!this.hasSomethingToAdd(index)) {
                console.log('[WRT] Nothing to add to cart');
                return;
            }
            var res = this.winresReservationContext;
            var line = res.findOrCreateProductLineByProduct(this.retrievedProducts[index][0]);

            // Temporary check until multiple product support is implemented for Opera.
            if (this.allowBookingOnlyOne(this.retrievedProducts[index]) && line.Amount > 0) {
                console.warn('[WRT] Can only book one of this product.');
                return;
            }

            line.TotalPrice = 0;
            line.UnitPrice = null;
            //console.log("line", line);
            var numPrices = 0;
            var passengerAssignments = [];

            for (var i = 0; i < this.prices[index].length; ++i) {
                var price = this.prices[index][i];
                var chosenAmount = this.chosenAmounts[index][i];
                if (chosenAmount > 0) {
                    numPrices++;
                    line.UnitPrice = price.Price;
                    if (this.useDummyPassengers(this.retrievedProducts[index])) {
                        ++line.Amount;
                        var productNumber = line.Amount;
                        console.log('[WRT] Selected product is an Opera product. Assigning dummy passengers.');
                        this.assignDummyPassengersToProductLine(line, productNumber);
                    } else {
                        res.addExtraServiceToPassenger(this.retrievedProducts[index][0], 0, chosenAmount, null, null);
                    }
                    if (price.Index !== null) {
                        var priceSelection = res.findOrCreatePriceSelection(price.Index, line);
                        priceSelection.Amount += chosenAmount;
                    }

                    line.TotalPrice += chosenAmount * price.Price;
                    line.TaxPercent = this.TaxPercent[i];
                }
            }

            if (numPrices > 1) {
                line.UnitPrice = null;
            }
            this.$scope.justAddedToCart = [];
            this.$scope.justAddedToCart[index] = true;
            this.$timeout(function () {
                _this4.$scope.justAddedToCart[index] = false;
            }, 5000);

            //console.log('calling onAdd');
            this.onAdd({ 'window': window });
            //console.log('after calling onAdd');
        }
    }, {
        key: 'assignDummyPassengersToProductLine',
        value: function assignDummyPassengersToProductLine(productLine, productNumber) {
            var passengerAmounts = {
                adults: this.data.NumAdults || 0,
                children: this.data.NumChildren || 0,
                infants: this.data.NumInfants || 0
            };
            // console.log('[WRT] Assigning dummy passengers. Amounts:', passengerAmounts);
            var eventDate = moment(productLine.Product.BeginDate);
            var res = this.winresReservationContext;
            var passengerIndexes = res.getOrCreateDummyPassengers(eventDate, passengerAmounts, this.data.ChildrenAges);
            productLine.PassengerAssignments = _.map(passengerIndexes, function (index) {
                return {
                    PassengerNumber: index,
                    ProductNumber: productNumber,
                    Comment: null,
                    Comment2: null
                };
            });
            //console.log('[WRT] Assigned', passengerIndexes.length, 'dummy passengers.');
            // console.log('[WRT] Product line:', productLine);
            // console.log('[WRT] All passengers:', this.data.Passengers);
        }
    }, {
        key: 'hasSomethingToAdd',
        value: function hasSomethingToAdd(i) {
            return this.retrievedProducts[i] !== null && _.some(this.chosenAmounts[i], function (amount) {
                return amount > 0;
            });
        }
    }, {
        key: 'resetSearchProduct',
        value: function resetSearchProduct() {
            // console.log('[WRT] Resetting search product');
            this.searchProducts = [];
            this.retrievedProducts = [];
        }
    }, {
        key: 'updateEndDateIfLengthIsForced',
        value: function updateEndDateIfLengthIsForced(startDate, index) {
            if (startDate == null) return;
            if (this.searchProducts[index] === null) return;
            var forceReservedDays = this.searchProducts[index].ForceReservedDays;
            if (forceReservedDays === null) {
                if (this.terms[index].endDate <= startDate) {
                    this.terms[index].endDate = addDays(1, startDate);
                }
                return;
            }
            // console.log('[WRT] Updating end date due to forced length:', forceReservedDays);
            this.terms[index].endDate = addDays(forceReservedDays, startDate);
        }

        // Temporary solutions for Opera problems. Should be replaced with something
        // more permanent if they are still needed later.

    }, {
        key: 'useDummyPassengers',
        value: function useDummyPassengers(product) {
            return this.isOperaProduct(product);
        }
    }, {
        key: 'allowBookingOnlyOne',
        value: function allowBookingOnlyOne(product) {
            return this.isOperaProduct(product);
        }
    }, {
        key: 'isOperaProduct',
        value: function isOperaProduct(product) {
            return product.DataSources && product.DataSources.Capacity === "Opera";
        }
    }, {
        key: 'selectEnoughRoomsForPassengers',
        value: function selectEnoughRoomsForPassengers(bedsInRoom, extraBedsInRoom, adults, children) {
            var rooms = 0;

            while (adults > 0) {
                ++rooms;

                var freeBeds = bedsInRoom;
                var freeExtraBeds = extraBedsInRoom;

                // 1) Accommodate one adult in the room (a room must have one adult)
                --adults;
                --freeBeds;

                // 2) Accommodate as many children in extra beds as will fit
                var childrenInExtraBeds = Math.min(freeExtraBeds, children);
                children -= childrenInExtraBeds;
                freeExtraBeds -= childrenInExtraBeds;

                // 3) Accommodate as many children in regular beds as will fit
                var childrenInBeds = Math.min(freeBeds, children);
                children -= childrenInBeds;
                freeBeds -= childrenInBeds;

                // 4) Accommodate as many adults in regular beds as will fit.
                //    Note that this will only happen if all children have already
                //    been accommodated.
                var adultsInBeds = Math.min(freeBeds, adults);
                adults -= adultsInBeds;
                freeBeds -= adultsInBeds;

                // 5) If adults can be accommodated in extra beds, do it here.
                // In the future, this information should come from a parameter.
                // Currently, assume adults cannot be accommodated in extra beds.
            }

            // If there were any children left over, this should fail. This can
            // happen when there too few adults to put one in each room required for
            // the children.
            if (children > 0) {
                console.warn('[WRT] Cannot accommodate all children in rooms with at least one adult.');
                return null;
            }

            //console.log('[WRT] Selected', rooms, 'rooms.');

            return rooms;
        }
    }, {
        key: 'getReservableProducts',
        value: function getReservableProducts(params) {
            var language = this.localizationService.getLanguage();
            params.MinCapacity = 1;
            return this.productService.getReservableProducts(params, language);
        }

        // this function gets the total capacity and selected amounts.

    }, {
        key: 'getCapacityForSelect',
        value: function getCapacityForSelect(parentIndex, index) {
            var capacity = this.availableAmounts[parentIndex];
            var selectedAmounts = this.chosenAmounts[parentIndex];
            var totalCapacity = _.last(capacity);

            var totalAmount = 0;
            _.each(selectedAmounts, function (amount) {
                totalAmount += amount;
            });

            var available = totalCapacity - totalAmount + this.chosenAmounts[parentIndex][index];
            return _.range(0, available + 1);
        }
    }]);

    return WinresReservationTicketExtraServices;
}();

WinresReservationTicketExtraServices.$inject = ['$scope', '$timeout', '$location', 'productService', 'localizationService', '$document'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils2.getWebcomponentsUrl)($attrs.templateUrl)) : 'reservation-ticket-extra-services';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('reservation-ticket-extra-services', require('./winresReservationTicketExtraServices.html'));
}]);

_module3.default.component('winresReservationTicketExtraServices', {
    templateUrl: getTemplate,
    controller: WinresReservationTicketExtraServices,
    bindings: {
        // Scope has window. thus, window.$('.shopping-cart').show() works in on-add.
        onAdd: '&',
        // Text to show when after selecting dates no products cna be reserved.
        notReservableText: '@',
        // type code for when item should be treated as package (this.data.Destination.Type)
        packageType: '@'
    },
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});

function addDays(days, date) {
    var next = new Date(date.getTime());
    next.setDate(next.getDate() + days);
    return next;
}


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationTicketExtraServices/winresReservationTicketExtraServices.js
// module id = 433
// module chunks = 2